import React from "react"
import { useTranslation } from "react-i18next"

const LANGUAGES = [
  { code: "pt", label: "PT" },
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
]

export default function LanguageSwitcher({ dark = false, compact = false }: { dark?: boolean; compact?: boolean }) {
  const { i18n } = useTranslation()
  const current = (i18n.language || "en").slice(0, 2)
  const activeIndex = Math.max(
    0,
    LANGUAGES.findIndex((language) => language.code === current)
  )

  if (compact) {
    const active = LANGUAGES[activeIndex]
    const next = LANGUAGES[(activeIndex + 1) % LANGUAGES.length]
    return (
      <button
        type="button"
        title={`${active.label} → ${next.label}`}
        aria-label={`Language: ${active.label}. Switch to ${next.label}`}
        onClick={() => i18n.changeLanguage(next.code)}
        style={{
          border: "1px solid #e7e9ee",
          borderRadius: 999,
          background: "#ffffff",
          color: "#5b6484",
          padding: "3px 9px",
          fontSize: "0.68rem",
          fontWeight: 700,
          letterSpacing: "0.02em",
          cursor: "pointer",
        }}
      >
        {active.label}
      </button>
    )
  }

  return (
    <div style={{ display: "flex", gap: "0.25rem" }}>
      {LANGUAGES.map((language) => {
        const active = current === language.code
        return (
          <button
            key={language.code}
            type="button"
            onClick={() => i18n.changeLanguage(language.code)}
            style={{
              border: 0,
              borderRadius: 6,
              padding: "0.25rem 0.5rem",
              fontSize: "0.72rem",
              fontWeight: 600,
              cursor: "pointer",
              background: active ? (dark ? "#ffffff" : "#192bc2") : "transparent",
              color: active ? (dark ? "#111827" : "#ffffff") : dark ? "#d1d5db" : "#5b6484",
            }}
          >
            {language.label}
          </button>
        )
      })}
    </div>
  )
}
